export default "__VITE_ASSET__Yhi4CATZ__"